import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  searchQuery: '',
  statusFilter: 'all',
  includeInactive: false,
  currentPage: 1,
  formDraft: null,
  isExitWarningOpen: false,
};

const patientsSlice = createSlice({
  name: 'patients',
  initialState,
  reducers: {
    setSearchQuery: (state, action) => {
      state.searchQuery = action.payload;
      state.currentPage = 1; // Reset to first page on search
    },
    setStatusFilter: (state, action) => {
      state.statusFilter = action.payload;
      state.currentPage = 1; // Reset to first page on filter change
    },
    setIncludeInactive: (state, action) => {
      state.includeInactive = !!action.payload;
      state.currentPage = 1;
    },
    toggleIncludeInactive: (state) => {
      state.includeInactive = !state.includeInactive;
      state.currentPage = 1;
    },
    setCurrentPage: (state, action) => {
      state.currentPage = action.payload;
    },
    setFormDraft: (state, action) => {
      state.formDraft = action.payload;
    },
    clearFormDraft: (state) => {
      state.formDraft = null;
    },
    setExitWarningOpen: (state, action) => {
      state.isExitWarningOpen = action.payload;
    },
    resetFilters: (state) => {
      state.searchQuery = '';
      state.statusFilter = 'all';
      state.includeInactive = false;
      state.currentPage = 1;
    },
  },
});

export const {
  setSearchQuery,
  setStatusFilter,
  setIncludeInactive,
  toggleIncludeInactive,
  setCurrentPage,
  setFormDraft,
  clearFormDraft,
  setExitWarningOpen,
  resetFilters,
} = patientsSlice.actions;

// Selectors
export const selectSearchQuery = (state) => state.patients.searchQuery;
export const selectStatusFilter = (state) => state.patients.statusFilter;
export const selectIncludeInactive = (state) => state.patients.includeInactive;
export const selectCurrentPage = (state) => state.patients.currentPage;
export const selectFormDraft = (state) => state.patients.formDraft;
export const selectIsExitWarningOpen = (state) => state.patients.isExitWarningOpen;

export default patientsSlice.reducer;
